// extracted by mini-css-extract-plugin
export default {"root":"QuoteSection__root--Oc7nW","header":"QuoteSection__header--zN_xg","subtotal":"QuoteSection__subtotal--xSDmt","items":"QuoteSection__items--tmyat"};